import React, { useState } from 'react';
import axios from 'axios';
import '../Pincodefinder/Style.css';
import '../Steelcity/css/style.css'





import Logo from '../Logo/logo.png';
import Swal from 'sweetalert2';

const SteelCityTracking = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<any[]>([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const statusToStep: { [key: string]: number } = {
    'Booked': 1,
    'InTransit': 2,
    'DELIVERED': 3,
    'Delivered': 4,
  };

  const handleButtonClick = () => {
    setShowImage(!showImage);
  };

  const fetchData = async () => {
    try {
      const trimmedInputs = searchValue
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item.length > 0);

      if (trimmedInputs.length === 0) {
        setError('Please enter one or more tracking numbers separated by commas.');
        return;
      }

      const awbNumbers = trimmedInputs.filter((item) => /^\d+$/.test(item));
      const refNumbers = trimmedInputs.filter((item) => /\D/.test(item));

      let queryParams: { awbNo?: string; refNo?: string } = {};

      if (awbNumbers.length > 0) {
        queryParams.awbNo = awbNumbers.join(',');
      }
      if (refNumbers.length > 0) {
        queryParams.refNo = refNumbers.join(',');
      }

      const res = await axios.get('https://trackerex.com/TrackingDabhlogisticApi/TrackingData', {
        params: queryParams,
      });

      const data = res.data;

      console.log(data, 'arjun ');


      if (data?.status === 1 && Array.isArray(data.data)) {
        const tryImageExtensions = async (awbNo: string): Promise<string | null> => {
          const extensions = ['jpg', 'jpeg', 'png'];
          for (const ext of extensions) {
            const url = `https://trackerex.com/PODImg/${awbNo}.${ext}`;
            const exists = await checkImageExists(url);
            if (exists) return url;
          }
          return null;
        };

        const checkImageExists = (url: string): Promise<boolean> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
          });
        };

        const fetchImageLinks = async () => {
          const updatedData = await Promise.all(data.data.map(async (item: any) => {
            const imageUrl = await tryImageExtensions(item.awbNo);
            return {
              ...item,
              ImageLink: imageUrl, // null if no image found
            };
          }));

          setTrackingData(updatedData);
          setError('');
          setSearchValue('');

          if (updatedData.length > 0) {
            const status = updatedData[0].Status;
            setCurrentStep(statusToStep[status] || 1);
          }
        };

        fetchImageLinks();
      } else {
        setTrackingData([]);
        Swal.fire({
          icon: 'warning',
          title: 'Docket Not Found',
          text: 'The entered docket number was not found.',
        });
      }
    } catch (error: any) {
      console.error('Error:', error);
      setTrackingData([]);
      setError(
        error.response?.data?.message ||
        'Failed to fetch data. Please check your internet connection.'
      );
    }
  };

  return (
    <>
      <div className="container-fluid py-3">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 text-center text-lg-start mb-3 mb-lg-0">
            <img
              src={Logo}
              alt="Company Logo"
              className="img-fluid"
              style={{ maxWidth: '400px', height: '50px' }}
            />
          </div>
          <div className="col-12 col-lg-6 text-center text-lg-end">
            {/* <div className="mb-2">
              <a href="https://www.steelcourier.com/index.html" className="btn btn-outline-primary">
                Back To Home
              </a>
            </div> */}
            <div className="fw-semibold">
              📞 9213097800, 8750506770
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-light bg-danger">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">Steel Courier & Cargo</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="https://www.steelcourier.com/index.html">Home</a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a className="dropdown-item" href="https://www.steelcourier.com/about-us.html">Profile</a></li>
                  <li><a className="dropdown-item" href="https://www.steelcourier.com/viss.html">Vision</a></li>
                  <li><a className="dropdown-item" href="#">Mission</a></li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.steelcourier.com/services.html">Services</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="https://trackerex.com/TrackingSteelcity/">Tracking</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.steelcourier.com/contact.html">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>


      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="shadow p-4">
              <input
                type="text"
                placeholder="Tracking Number(s)"
                className="form-control mb-2 text-center border border-info"
                value={searchValue}
                onChange={handleInputChange}
              />
              <button onClick={fetchData} className="Track1 w-100">TRACK HERE</button>
              {error && <div className="text-danger mt-2">{error}</div>}
              <p className="mt-2">To track multiple AwbNo</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center">Tracking Details</h5>
                <table className="table table-bordered table-sm mb-4">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Ref_No</th>
                      <th>BookDate</th>
                      <th>Consignee_Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.awbNo}</td>
                      <td>{record.refNo || '-'}</td>
                      <td>{record.bookDate}</td>
                      <td>{record.consigneeName}</td>
                      <td>{record.Status}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Qty</th>
                      <th>Destination</th>
                      <th>Receiver Name</th>
                      <th>Delivery Date</th>
                      <th>Delivery Time</th>
                      {/* <th>Contact_No</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.Qty}</td>
                      <td>{record.destinationName}</td>
                      <td>{record.recvName}</td>
                      <td>{record.DelvDT}</td>
                      <td>{record.DelvTime}</td>
                      {/* <td>{record.Destination_PIN}</td> */}
                    </tr>

                    <tr>
                      <th>Mobile_No</th>
                      <td>{record.Destination_PIN}</td>
                      <td colSpan={5}>
                        <button className="btn btn-success" onClick={handleButtonClick}>
                          {showImage ? 'Hide Image' : 'Pod Image'}
                        </button>
                        {showImage && (
                          <div className="image-container mt-2 text-center">
                            <img src={record.ImageLink} alt="Podimages" className="img-fluid" />
                          </div>
                        )}
                      </td>

                    </tr>
                    <tr>

                    </tr>


                  </tbody>
                </table>



                <div className="w-100 position-relative" style={{ paddingBottom: '30px' }}>
                  {/* Background Progress Line */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      left: 0,
                      right: 0,
                      height: '4px',
                      backgroundColor: '#ccc',
                      zIndex: 0,
                    }}
                  >
                    <div
                      style={{
                        width: `${((currentStep - 1) / 2) * 100}%`, // since 3 steps → 2 gaps
                        height: '100%',
                        backgroundColor: '#007bff',
                        transition: 'width 0.3s ease',
                      }}
                    ></div>
                  </div>

                  {/* Step Circles and Labels */}
                  <div className="steps-container d-flex justify-content-between align-items-center my-3" style={{ position: 'relative', zIndex: 1 }}>
                    {['Booked', 'InTransit', 'DELIVERED'].map((stepLabel, index) => {
                      const normalizedLabel = stepLabel.toLowerCase();
                      const stepNum = index + 1;
                      const isActive = stepNum <= currentStep;

                      return (
                        <div key={normalizedLabel} className="text-center" style={{ flex: 1 }}>
                          <div
                            className={`step-circle ${isActive ? 'active' : ''}`}
                            style={{
                              width: '30px',
                              height: '30px',
                              borderRadius: '50%',
                              backgroundColor: isActive ? '#007bff' : '#ccc',
                              color: 'white',
                              lineHeight: '30px',
                              margin: '0 auto',
                              fontWeight: 'bold',
                            }}
                          >
                            {stepNum}
                          </div>
                          <div className="step-label mt-2">
                            {normalizedLabel.charAt(0).toUpperCase() + normalizedLabel.slice(1)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>


              </div>
            ))}

            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center"> Status Tracking </h5>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Status_Date</th>
                      <th>Status_Time</th>
                      <th>Location_Update</th>
                      <th>Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.podHistory?.map((history: any, idx: number) => (
                      <tr key={idx}>
                        <td>{history.Awbno}</td>
                        <td>{history.DelvDt}</td>
                        <td>{history.DelvTime}</td>
                        <td>{history.Destination_Name}</td>
                        <td>{history.Remark}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            ))}
          </div>
        </div>
      </div>
      <footer>
        <div className="row foot">
          <div className="col-md-3">
            <div className="col-md-3">
              <p style={{ textAlign: 'left' }}>
                <h3>
                  <strong className="link">LINK</strong>
                </h3>

                <p><a href="about-us.html">Profile</a></p>
                <p><a href="networks.html">Services</a></p>
                <p><a href=".html">Document</a></p>
                <p><a href="contact.html">Contact Us</a></p>
              </p>
            </div>
            <p><a href="networks.html"></a></p>
          </div>
          <div className="col-md-3">
            <p style={{ textAlign: 'left' }}>
              <h3>
                <strong className="link">SERVICES</strong>
              </h3>
            </p>
            <p><a href="air-freight.html">Air Freight</a></p>
            <p><a href="surface-freight.html">Surface Freight</a></p>
            <p><a href="rail-freight.html">Rail Freight</a></p>
            <p>&nbsp;</p>
          </div>

          <div className="col-md-3">
            <p style={{ textAlign: 'left' }}>
              <h3>
                <strong className="link">CALL US</strong>
              </h3>
            </p>
            <p><a href="get-quote.html">PHONE NO- 45586770,9266600562, 9213097800,8750506770</a></p>
            <p><a href="terms-conditions.html"></a></p>
            <p><a href="sitemap.html"></a></p>
          </div>

          <div className="col-md-3">
            <p style={{ textAlign: 'left' }}>
              <h3>
                <strong className="link">CONTACT DETAILS</strong>
              </h3>
            </p>
            <p>
              <span className="white">
                Flat No-24, Shankat market,<br />
                Connaught Place, New Delhi-110001
              </span>
            </p>
            <p>Email:</p>
            <p>&nbsp;</p>
            <div className="row">
              <div className="col-md-12">
                <p style={{ textAlign: 'left' }}>
                  <h4>
                    <strong className="link">CONNECT US</strong>
                  </h4>
                </p>
                <img src="images/facebook.png" alt="" />&nbsp;&nbsp;
                <img src="images/youtube.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <br />
      </footer>

    </>
  );
};

export default SteelCityTracking;









